// Development mode toggle — only the literal string 'true' enables it. Default
// is false so production builds without the env var are safe. Wire-up only;
// fully seeding a mock-auth session for end-to-end tour testing is a follow-up.
export const DEV_MODE = import.meta.env.VITE_DEV_MODE === 'true';

// Mock user data
export const MOCK_USER = {
  id: 'dev-user-123',
  email: 'test@example.com',
  full_name: 'Test User',
  avatar_url: null,
  is_verified: true,
  created_at: new Date().toISOString(),
  has_password: true,
  // Subscription fields — full PRO so every tour step (incl. pro-gated copy)
  // shows. is_trial=false keeps the TrialBanner off so it doesn't overlap tour
  // popovers during Phase 4c visual QA.
  subscription_tier: 'pro' as const,
  is_pro: true,
  is_basic_plus: false,
  is_trial: false,
  trial_days_remaining: 0,
  trial_ended: false,
  is_admin: false,  // Set to true to test admin bypass
};

// Mock generated posts (no preset emojis - LLM will add them when relevant)
export const MOCK_GENERATED_POSTS = {
  instagram: {
    content: "Transform your business with cutting-edge technology!\n\nAt Acme Corp, we don't just build solutions – we create experiences that drive growth.\n\nReady to take your business to the next level? Let's talk!\n\n#DigitalTransformation #BusinessGrowth #Innovation",
    principles_used: ['Social Proof', 'Urgency & Scarcity'],
    posting_tips: 'Best time to post: 11am-1pm or 7-9pm. Use relevant hashtags and engage with comments within the first hour.',
  },
  linkedin: {
    content: "In today's competitive landscape, businesses that embrace digital transformation don't just survive – they thrive.\n\nAt Acme Corp, we've helped over 100 businesses modernize their operations and increase efficiency by an average of 40%.\n\nHere's what sets us apart:\n- Custom solutions tailored to your needs\n- Dedicated support team\n- Proven track record of results\n\nCurious how we can help your business? Let's connect.",
    principles_used: ['Authority', 'Social Proof'],
    posting_tips: 'Best time to post: Tuesday-Thursday, 8-10am or 12pm. Tag relevant industry leaders and companies.',
  },
  facebook: {
    content: "Did you know that 73% of businesses see improved customer satisfaction after digital transformation?\n\nAt Acme Corp, we make technology work for YOU. Whether you need a new website, better marketing, or streamlined operations – we've got you covered.\n\nMessage us today for a free consultation!\n\n#SmallBusiness #Technology #Growth",
    principles_used: ['Availability Heuristic', 'Reciprocity'],
    posting_tips: 'Best time to post: 1-4pm. Include a clear call-to-action and respond to all comments.',
  },
  twitter: {
    content: "Quick wins for your business:\n\n- Automate repetitive tasks\n- Optimize your website for mobile\n- Use data to drive decisions\n\nWant personalized advice? DM us!\n\n#BusinessTips #DigitalTransformation",
    principles_used: ['Framing', 'Loss Aversion'],
    posting_tips: 'Best time to post: 9am or 12pm. Use 1-2 relevant hashtags and keep it concise.',
  },
};

// Generate mock variants (no preset emojis)
export function generateMockVariants(platform: string) {
  const base = MOCK_GENERATED_POSTS[platform as keyof typeof MOCK_GENERATED_POSTS];
  if (!base) return [];
  
  return [
    base.content,
    `${base.content.split('\n')[0]}\n\n${base.content.split('\n').slice(1).join('\n')}\n\n#growth`,
    `${base.content}\n\nThoughts?`,
  ];
}

// Mock company profile (legacy - used by api.ts in DEV_MODE)
export const MOCK_COMPANY_PROFILE = {
  id: 'mock-company-1',
  name: 'Acme Corporation',
  website_url: 'https://acme.example.com',
  industry: 'Technology',
  description: 'A leading provider of innovative solutions',
  target_audience: 'Small to medium businesses',
  brand_voice: 'Professional, innovative, customer-focused',
  created_at: new Date().toISOString(),
  updated_at: new Date().toISOString(),
};

// Mock services (legacy - used by api.ts in DEV_MODE)
export const MOCK_SERVICES = [
  {
    id: 'service-1',
    name: 'Consulting',
    description: 'Expert advice and strategy',
    display_order: 0,
    is_active: true,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
  {
    id: 'service-2',
    name: 'Development',
    description: 'Custom software solutions',
    display_order: 1,
    is_active: true,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
];
